import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientLoginFlowQuestionUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getQuestionsForLogin(req);
    }
}
export default ClientLoginFlowQuestionUseCase;
